export default {
	headerSearch: {
  "preferences": "Tema e idioma",
  "collapsed": "Buscar…",
  "open": "Buscar personas y guías",
  "placeholder": "Consultante, médium o guía…",
  "hint": "Escribe al menos 2 caracteres.",
  "empty": "No se encontraron resultados.",
  "error": "No se pudieron cargar todos los resultados. Inténtalo de nuevo.",
  "limit": "Hasta 5 resultados por categoría. Precisa el nombre para encontrar más.",
  "primaryMedium": "Médium principal: {name}",
  "noPrimary": "Sin médium principal",
  "consulente": "Consultante",
  "medium": "Médium",
  "guide": "Guía"
},
	active: "Activo",
	inactive: "Inactivo",
	status: "Estado",
	actions: "Acciones",
	notFinished: "No finalizado",
	save: "Guardar",
	cancel: "Cancelar",
	edit: "Editar",
	delete: "Eliminar",
	create: "Crear",
	update: "Actualizar",
	add: "Agregar",
	change: "Cambiar",
	remove: "Quitar",
	close: "Cerrar",
	typeToSearch: "Escriba para buscar",
	years: "años",
	view: "Ver",
	details: "Detalles",
	loading: "Cargando...",
	loadMore: "Cargar más",
	search: "Buscar",
	searchField: "Búsqueda",
	filter: "Filtrar",
	print: "Imprimir",
	createdAt: "Creado en",
	description: "Descripción",
	notes: "Observaciones",
	endedAt: "Finalizado en",
	notSpecified: "No especificado",
	activate: "Activar",
	deactivate: "Desactivar",
	since: "Desde",
	showActiveOnly: "Mostrar solo activos",
	confirm: "Confirmar",
	confirmDelete: "Confirmar Eliminación",
	all: "Todos",
	back: "Volver",
	showMore: "Mostrar más",
	showLess: "Mostrar menos",
	error: "Error al realizar operación",
	unknown: "Desconocido",
	unnamed: "Sin nombre",
	yes: "Sí",
	no: "No",
	start: "Iniciar",
	complete: "Completar",
	createdBy: "Creado por",
	lastUpdate: "Última actualización",
	invalidValue: "Valor inválido",
	errorLoading: "Error al cargar datos",
	errorSaving: "Error al guardar datos",
	next: "Siguiente",
	required: "Campo obligatorio",
	saved: "Guardado con éxito",
	timestamps: "Fechas del Sistema",
	viewDetails: "Ver Detalles",
	optional: "opcional",
};
